import { indexTopics } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">精彩专题</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">探索擦边视频与擦边图片的各类精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexTopics.map((topic) => (
            <a
              key={topic.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-3 md:gap-4 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${topic.icon} text-primary-500 text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">{topic.title}</h3>
                <p className="text-xs text-foreground-500 truncate">{topic.desc}</p>
              </div>
              <div className="flex-shrink-0 text-xs font-medium text-primary-500 bg-primary-50 px-2 py-1 rounded whitespace-nowrap">
                {topic.count}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}